import { render, staticRenderFns } from "./GasConsumptionSettings.vue?vue&type=template&id=c490afee&scoped=true&"
import script from "./GasConsumptionSettings.vue?vue&type=script&lang=ts&"
export * from "./GasConsumptionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GasConsumptionSettings.vue?vue&type=style&index=0&id=c490afee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c490afee",
  null
  
)

export default component.exports